import { useEffect, useState } from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';

import NamePatterns from '@/pages/project/name-patterns/name-patterns.tsx';
import Patterns from '@/pages/project/patterns/patterns.tsx';
import Receipts from '@/pages/project/receipts/receipts.tsx';
import Transfers from '@/pages/project/transfers/transfers.tsx';
import { useAuth } from './api/auth/use-auth.ts';
import { AuthContext } from './context/auth-context.tsx';
import Layout from './layout';
import Home from './pages/home/home.tsx';
import Login from './pages/login/login.tsx';
import Categories from './pages/project/categories/categories.tsx';

const App = () => {
  const [enabled, setEnabled] = useState(true);

  const { data, isLoading } = useAuth(enabled);

  useEffect(() => {
    if (!!data !== enabled) {
      setEnabled(!!data);
    }
  }, [data]);

  if (isLoading) {
    return <>Oh no, I am loading the app</>;
  }

  if (!data) {
    return (
      <RouterProvider
        router={createBrowserRouter([
          { path: '/', element: <Login /> },
          { path: '*', element: <>Oh not found</> },
        ])}
      />
    );
  }

  return (
    <AuthContext.Provider value={{ user: data }}>
      <RouterProvider
        router={createBrowserRouter([
          {
            element: <Layout />,
            children: [
              { path: '/', element: <Home /> },
              {
                path: '/projects/:projectId',
                children: [
                  { index: true, element: <>Project Overview Page</> },
                  {
                    path: 'receipts',
                    children: [
                      { index: true, element: <Receipts /> },
                      { path: ':receiptId', element: <Receipts /> },
                    ],
                  },
                  { path: 'categories', element: <Categories /> },
                  {
                    path: 'transfers',
                    children: [
                      { index: true, element: <Transfers /> },
                      { path: ':transferId', element: <Transfers /> },
                    ],
                  },
                  { path: 'patterns', element: <Patterns /> },
                  { path: 'name-patterns', element: <NamePatterns /> },
                ],
              },
              { path: '/auth/success', element: <Navigate to="/" /> },
              { path: '*', element: <>Oh not found</> },
            ],
          },
        ])}
      />
    </AuthContext.Provider>
  );
};

export default App;
